import React, { type FC, useMemo } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  copyingGroupStatsSelector,
  modalCopyState,
} from 'Pages/GroupsList/recoil/state/state'
import { Flex, FlexItem, ModalBody, ModalHead } from 'mailup-web-components'

import './ModalCopy.scss'

const ModalCopyConfirmStep: FC = () => {
  const intl = useIntl()

  const { group, newList } = useRecoilValue(modalCopyState)
  const stats = useRecoilValue(copyingGroupStatsSelector)

  return (
    <>
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.MailupCommon.Confirm',
        })}
      />
      <ModalBody>
        <Flex flexDirection="column" gap="16px">
          <FlexItem>
            {intl.formatMessage(
              {
                id: 'Load.CopyGroupToList.ConfirmQuestion',
              },
              {
                groupName: group?.Name,
                list: (
                  <strong>{`${newList?.IdList} - ${newList?.Name}`}</strong>
                ),
              },
            )}
          </FlexItem>
          <FlexItem>
            {intl.formatMessage({
              id: 'Load.CopyGroupToList.StatsIntro',
            })}
            <ul className="subslist">
              <li>
                {intl.formatMessage(
                  {
                    id: 'Load.CopyGroupToList.EmailSubs',
                  },
                  {
                    emailSubs: <strong>{stats?.EmailSubscribed}</strong>,
                  },
                )}
              </li>
              <li>
                {intl.formatMessage(
                  {
                    id: 'Load.CopyGroupToList.SmsSubs',
                  },
                  {
                    smsSubs: <strong>{stats?.SmsSubscribed}</strong>,
                  },
                )}
              </li>
            </ul>
          </FlexItem>
        </Flex>
      </ModalBody>
    </>
  )
}

export default ModalCopyConfirmStep
